export default {"src":"/_next/static/media/git-book.3be8d38d.svg","height":34,"width":159};